
import { mapActions, mapMutations } from 'vuex';
import Sender from '@razlet/sdk/lib/senders/base';
import CalendarFormRequest from '@razlet/sdk/lib/requests/asb/pricing/calendar-prices';

export default {
  name:'flight-page',
  layout: 'default',
  async asyncData ({ route }) {
    const { departure, arrival } = route.params;
    const sender = new Sender({ baseUrl: process.env.asb3URL });
    const description = await sender.get(`/api/web/popular-direction/${departure}/${arrival}`)
      .then(response => {
        return Promise.resolve(response.data);
      });
    return { description };
  },
  data(){
    return{
      description: {},
      daysWeek: ['ПН','ВТ','СР','ЧТ','ПТ','СБ','ВС'],
      currentMonth: '',
      nextCurrentMonth: '',
      columnStart:1,
      columnNextStart:1,
      directFlight: true,
      loading: false,
      isPricesLoading: false,
    };
  },
  computed: {
    time(){
      const result = this.description.flyTime.split(':');
      return `${Number(result[0])} ч ${Number(result[1])} мин`;
    },
    direction(){
      return `${ this.description.departure.name } - ${ this.description.arrival.name }`;
    },
    minCoast(){
      let min = 0;
      const coastIsNotNull = this.calendar.filter(item => item.price && item.price.value);
      if (coastIsNotNull.length){
        min = coastIsNotNull[0].price.value;
        coastIsNotNull.forEach((item)=>{
          min = item.price.value<min ? item.price.value : min;
        });
      }
      return min;
    },
    minCoastNext(){
      const coastIsNotNull = this.calendar.filter((item, indexItem)=>item.price&&item.price.value&&indexItem>=this.daysInMonth(this.currentMonth));
      return !!coastIsNotNull.length;
    },
    monthHeader(){
      const year = this.currentMonth.getFullYear()!== this.nextCurrentMonth.getFullYear()? `${this.currentMonth.getFullYear()} / ${this.nextCurrentMonth.getFullYear()}`: `${this.currentMonth.getFullYear()}`;
      return { month: `${this.currentMonth.toLocaleString('ru', { month: 'long' })} / ${this.nextCurrentMonth.toLocaleString('ru', { month: 'long' })}`, year };
    },
    calendar(){
      return this.$store.state.sdk.avia['search-form'].pricesList;
    },
    disablePreviousMonth(){
      return !(this.currentMonth.getMonth() > new Date().getMonth() || this.currentMonth.getFullYear() > new Date().getFullYear());
    },
  },
  watch:{
    directFlight:{
      handler(){
        this.updateCalendar();
      },
    },
  },
  created(){
    this.currentMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    this.nextCurrentMonth = this.generateNewDate(this.currentMonth, 1);
  },
  mounted(){
    this.updateCalendar();
  },
  methods: {
    ...mapActions('avia/search-form', ['loadPricesStatistic']),
    ...mapActions('avia/variants', ['getVariants']),
    ...mapMutations('avia/variants', ['clearFilter']),
    show(date){
      return new Date(date).getMonth() === this.currentMonth.getMonth();
    },
    disabledDate(date){
      return new Date(date) < new Date();
    },
    resultColumnStart(indexMonth){
      return indexMonth === 1? this.columnStart : this.columnNextStart;
    },
    nowDate(date){
      return new Date(date).getDate() === new Date().getDate() && new Date(date).getMonth() === new Date().getMonth();
    },
    daysInMonth(date){
      const year = date.getFullYear();
      const month = date.getMonth()+1;
      return new Date(year, month, 0).getDate();
    },
    selectedMonth(index){
      return index === 1? this.calendar.filter((item,indexItem)=>indexItem<this.daysInMonth(this.currentMonth)) :
        this.calendar.filter((item,indexItem)=>indexItem>=this.daysInMonth(this.currentMonth));
    },
    generateNewDate(date, number){
      let returnDate;
      const resultDate = new Date(date);
      if(resultDate.getMonth() + number < 0){
        const year = resultDate.getFullYear()-1;
        returnDate = new Date(year, '11', '01');
      }else if(resultDate.getMonth()+1 > 12){
        returnDate = new Date(resultDate, '01', '01');
      }else{
        returnDate = new Date(resultDate.getFullYear(), resultDate.getMonth() + number, '01');
      }
      return returnDate;
    },
    updateCalendarNext(){
      this.currentMonth = this.generateNewDate(this.currentMonth, 1);
      this.nextCurrentMonth = this.generateNewDate(this.currentMonth, 1);
      this.updateCalendar();
    },
    updateCalendarPrevious(){
      if(!this.disablePreviousMonth){
        this.currentMonth = this.generateNewDate(this.currentMonth, -1);
        this.nextCurrentMonth = this.generateNewDate(this.currentMonth, 1);
        this.updateCalendar();
      }
    },
    createSearch(date, potenalCreateSearch){
      if(potenalCreateSearch){
        const { departure, arrival } = this.description;
        const dataObjectForRequest = {
          segments: [
            {
              from: departure.codeEn,
              to: arrival.codeEn,
              date,
            },
          ],
          passengers: {
            aaa: 1,
            rbg: 0,
            rmg: 0,
          },
          cityFrom: {
            code: departure.codeEn,
            name: departure.name,
          },
          cityTo: {
            code: arrival.codeEn,
            name: arrival.name,
          },
          dates: {
            dateTo: date,
          },
          class: 'economy',
        };
        this.clearFilter();
        this.getVariants(dataObjectForRequest)
          .then(response => {

            this.$router.push({
              name: 'search-results',
              params: {
                uid: response.data.uid,
              },
              query: {
                search: JSON.stringify(dataObjectForRequest),
              },
            });
          });
      }
    },
    updateCalendar() {
      const { departure, arrival } = this.description;

      this.loadPricesStatistic(new CalendarFormRequest(
        {
          departure: arrival?.codeEn,
          arrival: departure?.codeEn,
          currency: process.env.currency,
          user: this.userData,
          startOffset: 0, 
          endOffset: 60,
        }
      ))
        .then(() => {
          this.columnStart = new Date(this.calendar[0].date).getDay();
          if (this.columnStart === 0) this.columnStart = 7;

          this.columnNextStart = new Date(this.calendar[this.daysInMonth(this.currentMonth)].date).getDay();
          if (this.columnNextStart === 0) this.columnNextStart = 7;
        });
    },
  },
};
